import classNames from "classnames";
// React
import React from "react";
import { resizeHelper } from "common/resizeHelper";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./Collapsable.less";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export default class Collapsable extends React.Component {
    componentDidMount() {
        this.sideBarExpander.addEventListener("transitionend", (event) => {
            if (event.propertyName === "width") {
                resizeHelper.forceResize();
            }
        });
    }
    render() {
        const { isOpen } = this.props;
        return (React.createElement("div", { ref: (div) => this.sideBarExpander = div, className: classNames(styles.pageSidebar, isOpen ? styles.expanded : styles.collapsed) }, this.props.children));
    }
}
